module.exports = __webpack_public_path__ + "static/media/Guanrong Wang.cc5483f2.png";